import React from "react";
import { FaSearch } from "react-icons/fa";

const SearchContainer = () => {
  return (
    <div>
      <div className="absolute p-4">
        <FaSearch className="text-[18px] text-textSecondary " />
      </div>
      <input
        type="search"
        name="search"
        id="search"
        placeholder="Search.."
        className="md:w-[350px] w-[250px] md:pl-14 pl-10 pr-5 h-12 bg-primary rounded-[30px] border border-gray-400"
      />
    </div>
  );
};

export default SearchContainer;
